module.exports = __webpack_public_path__ + "static/media/thumb.9ce7242b.jpg";